"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Object_1 = require("./_Object");
exports._ObjectList = {
    type: "list",
    flattened: true,
    member: {
        shape: _Object_1._Object
    }
};
//# sourceMappingURL=_ObjectList.js.map